import { createGenericSlice } from '../../../../../utils/slices'

export const rightHipSlice = createGenericSlice({
  name: 'rightHip',
  initialState: {
    type: 'truss',
    material: 5,
    width: 1.5,
    depth: 5.5,
    ply: 1,
    memberID: 'R.Hip 1',
    isDuplicate: true,
    load: 0,
    uplift: 0,
    // skewType: 2,
    skewAngle: 45,
    // slopeType: 0,
    slopeAngle: 0,
  },
})

export const rightHipActions = rightHipSlice.actions
